export default class MultipleElementsSelectModalController {

    constructor($scope, $injector, $uibModalInstance, bookingInformation, guestlist) {
        this.scope = $scope;
        this.injector = $injector;
        this.modalInstance = $uibModalInstance;
        this.guestlist = guestlist;
        this.bookingInformation = bookingInformation;
        this.angularState = this.injector.get('$state');
        this.translate = this.injector.get('$translate');

        this.elementInformation = bookingInformation[0].element;
    }

    dismiss() {
        this.modalInstance.dismiss();
    }

    close(selectedBookingInformation) {
        this.modalInstance.close(selectedBookingInformation);
    }
}

MultipleElementsSelectModalController.$inject = [
    '$scope',
    '$injector',
    '$uibModalInstance',
    'bookingInformation',
    'guestlist'
];



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/controllers/modals/seatplan/multiple-elements-select-modal.js